module.exports = __webpack_public_path__ + "static/img/role.0f8189e.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/swbnzk/role.png
// module id = 3ncW
// module chunks = 7